
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-pager--spacing-xs:var(--spacing-01);
  --sic-pager--spacing-s:var(--spacing-02);
  --sic-pager--spacing-m:var(--spacing-04);
  --sic-pager--spacing-l:var(--spacing-06);
  --sic-pager--color-text:var(--color-neutral-dark);
  --sic-pager--active-text:var(--color-primary-default);
  --sic-pager--active-primary-bg:var(--color-primary-default);

  --sic-pager--color-white-bg:var(--color-neutral-white);
  --sic-pager--color-neutral-bg:var(--color-primary-lightest);
}
`;